"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterData = exports.fetchUsers = void 0;
var fetchUsers = function () {
    return {
        users: [
            {
                id: 1,
                uuid: '11',
                email: 'john.doe@test.com',
                teams: ['team 1', 'team 2'],
                primary_course_name: 'Java',
                last_active_at: new Date().toLocaleDateString(),
            },
            {
                id: 2,
                uuid: '22',
                email: 'marry.jane@test.com',
                teams: ['team 1'],
                primary_course_name: 'HTTP',
                last_active_at: new Date().toLocaleDateString(),
            },
            {
                id: 3,
                uuid: '33',
                email: 'sidney.james@test.com',
                teams: [],
                primary_course_name: 'Java',
                last_active_at: new Date().toLocaleDateString(),
            },
        ],
    };
};
exports.fetchUsers = fetchUsers;
var getFilterData = function () {
    return {
        data: {
            badges_list: [
                {
                    id: 1,
                    display_name: 'Beginner Python',
                    icon_url: 'https://via.placeholder.com/100x100',
                    description: 'Awarded for completing the Beginner Python course',
                },
                {
                    id: 2,
                    display_name: 'Intermediate Python',
                    icon_url: 'https://via.placeholder.com/100x100',
                    description: 'Awarded for completing the Intermediate Python course',
                },
            ],
            lessons_list: [
                {
                    id: 1,
                    display_name: 'Intro to Python',
                    course_display_name: 'Python 101',
                    icon: 'https://via.placeholder.com/100x100',
                    type: false,
                },
                {
                    id: 2,
                    display_name: 'Object-Oriented Programming in Python',
                    course_display_name: 'Python 201',
                    icon: 'https://via.placeholder.com/100x100',
                    type: false,
                },
                {
                    id: 3,
                    display_name: 'Functional Programming in Python',
                    course_display_name: 'Python 301',
                    icon: 'https://via.placeholder.com/100x100',
                    type: true,
                },
            ],
            teams_list: [
                {
                    id: 1,
                    name: 'Python Enthusiasts',
                },
                {
                    id: 2,
                    name: 'Web Development Wizards',
                },
            ],
        },
    };
};
exports.getFilterData = getFilterData;
